module.exports = __webpack_public_path__ + "res/28-img_business_view_bg_rtl.1cd3437bccf057d1ad1dca0f02fab71e.png";